<template>
  <div>
    <el-row v-if="computedCurrentMerchant">
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="merchant-header" ref="merchant_header"> -->
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="merchant-header" :style="'background-image: url('+ computedCurrentMerchant.front_image_path +')'">
        <!-- <gmap-street-view-panorama class="merchant-header-header" :position="{lat: computedCurrentMerchant.coordinates[0], lng: computedCurrentMerchant.coordinates[1] }" :pov="pov" :zoom="1" @pano_changed="updatePano" @pov_changed="updatePov"></gmap-street-view-panorama> -->
        <el-row class="merchant-header-footer">
          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
            <div class="logo" :style="'background-image: url('+ computedCurrentMerchant.logo_img_path +')'"></div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20" :offset="4">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" :offset="1">
                <span class="title hidden-sm-and-down">{{ computedCurrentMerchant.title }}</span><br>
                <span class="description hidden-sm-and-down">{{ computedCurrentMerchant.short_description }}</span>
              </el-col>
              <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                <a :href="computedCurrentMerchant.social_instagram_url" target="_blank"><font-awesome-icon :icon="['fab', 'instagram']" size="2x" /></a>
                <a :href="computedCurrentMerchant.social_facebook_url" target="_blank"><font-awesome-icon :icon="['fab', 'facebook']" size="2x" /></a>
                <a :href="computedCurrentMerchant.social_twitter_url" target="_blank"><font-awesome-icon :icon="['fab', 'twitter']" size="2x" /></a>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="merchant-body">
        <el-row class="info">
          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
            <div class="description" v-if="computedCurrentMerchant.full_description">
              <h3>Descripción</h3>
              <p>{{ computedCurrentMerchant.full_description }}</p>
            </div>
            <div class="contact-information">
              <h3>Contacto</h3>
              <p v-if="computedCurrentMerchant.website"><font-awesome-icon :icon="['fas', 'globe']"  /><a :href="computedCurrentMerchant.website"> {{ computedCurrentMerchant.website }}</a></p>
              <p v-if="computedCurrentMerchant.email"><i class="el-icon-message"></i><a :href="'mailto:'+computedCurrentMerchant.email"> {{ computedCurrentMerchant.email }}</a></p>
              <p v-if="computedCurrentMerchant.address"><i class="el-icon-location"></i> {{ computedCurrentMerchant.address }}</p>
              <p v-if="computedCurrentMerchant.phone"><i class="el-icon-phone"></i><a :href="'tel:'+computedCurrentMerchant.phone"> {{ computedCurrentMerchant.phone }}</a></p>
              </p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
            <div class="map" v-if="computedCurrentMerchant" >
              <GmapMap
              ref="merchantMap"
              :center="getCurrentMapCenter"
              :zoom="zoom"
              :options="{ styles: style }"
              >

              <GmapMarker
              :position="getCurrentMapCenter"
              :icon="{ url: default_marker }"
              />

            <!-- <gmap-info-window v-if="getCurrentMerchant" :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
              {{ getCurrentMerchant.title }}
              <div>
                <v-icon v-for="icon in getCurrentMerchant.categoriesIcons" :name="icon"/>
              </div>
            </gmap-info-window> -->
              </GmapMap>
            </div>
            <!-- <div class="gallery">
              <h3>Fotos</h3>
            </div> -->
          </el-col>
        </el-row>
        <el-row class="panorama">
          <h3>Street View</h3>
          <gmap-street-view-panorama class="map" :position="getCurrentMapCenter" :pov="pov" :zoom="1" @pano_changed="updatePano" @pov_changed="updatePov"></gmap-street-view-panorama>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="tags"></el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="categories"></el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  name: "MainMerchantView",
  data() {
    return {
      currentCity: null,
      currentMerchant: null,
      currentLocationUrlPath: null,
      pov: null,
      pano: null,
      zoom: 15,
      style: require("@/assets/styles/default.json"),
      default_marker: require("@/assets/img/marker.png"),
    };
  },
  computed: {
    computedCurrentMerchant(){
      if(! _.isEmpty(this.$store.getters['app/currentMerchant']) ){
        return this.$store.getters['app/currentMerchant'];
      }
    },
    getCurrentMapCenter(){
      if(! _.isEmpty(this.$store.getters['app/currentMerchant']) ){
        return { lat: this.$store.getters['app/currentMerchant'].coordinates[0], lng: this.$store.getters['app/currentMerchant'].coordinates[1] }
      }
    }
  },
  methods: {
    updatePov(pov) {
      this.pov = pov;
    },
    updatePano(pano) {
      this.pano = pano;
    },
    loadCurrentCity() {
      let self = this;
      self.$store.dispatch("listCities", { params: { country: self.$route.params.country, title: self.$route.params.city } })
      .then(response => {
        self.currentCity = _.head(response.data);
        this.loadCurrentMerchant();
      }).catch(error => {
        console.log(error);
      });
    },
    loadCurrentMerchant() {
      let self = this;
      // self.$store.dispatch("getMerchantByDescription", { params: { country: self.$route.params.country, city: self.currentCity.id, title: self.$route.params.merchant } })
      self.$store.dispatch("listMerchants", { params: { city: self.currentCity.id } })
      .then(response => {
        self.currentMerchant = _.head(_.filter(response.data, (merchant) => merchant.title.toLowerCase() === self.$route.params.merchant ));

        self.$store.dispatch("app/setMerchant", { merchant: self.currentMerchant } )
        .catch(error => {
          console.log(error);
        });

      }).catch(error => {
        console.log(error);
      });
    },
    setCurrentMerchant(){
      let self = this;

      self.$store.dispatch('getMerchant',{ params: { 'url_path': '/' + self.$route.params.country + '/' + self.$route.params.city + '/' +self.$route.params.merchant } })
      .then((response) => {
        self.currentMerchant = response.data[0];
        self.$store.dispatch("app/setMerchant", { merchant: self.currentMerchant })
        .then(() => {
          // Promise.all([self.loadSidebarCategories(), self.loadCityLocations()]).then(() => self.setMerchants());
        })
        .catch(error => {
          console.log(error);
        });
      })
      .catch(error => {
        console.log(error);
      });
    }
  },
  mounted(){

    // random background
    // if(this.$refs.merchant_header.$el){
    //     this.$refs.merchant_header.$el.classList.add('bg-'+_.random(1, 13));
    // }
  },
  created(){
    if (window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerendered) {
      return;
    }
    let self = this;

    if(this.$store.state.app){
      if(_.isEmpty(this.$store.getters['app/currentMerchant'])){ console.log('current Merchant empty')
        // self.setCity(this.$route.params.city, this.$route.params.country);
        self.setCurrentMerchant();
      }
      else{
        this.currentMerchant = this.$store.getters['app/currentMerchant'];
        // Promise.all([this.loadSidebarCategories(), this.loadCityLocations()]).then(() => this.setMerchants());
      }
    }
    else{
      console.log('without app vars')
      // self.setCenter(item.title, item.country);
    }

    // if(this.$store.state.app && !_.isEmpty(this.$store.state.app.currentMerchant)){
    //   this.currentMerchant = this.$store.getters['app/currentMerchant'];
    // }else{
    //   this.loadCurrentCity();
    // }
  },
};
</script>
<style>
.merchant-header{
  position: relative;
  min-height: 30vh;
  background-size: cover;
  /* padding-top: 25vh; */
  .el-button{ color: grey; }
  .logo{
    background-color: white;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: inline-block;
    border-radius: 50%;
    height: 11rem; width: 11rem;
    top: -13vh;
    left: 5vh;
    border: solid 0.5rem white;
    position: absolute;
    z-index: 1;
  }
  .merchant-header-header{
    min-height: 35vh;
    position: absolute;
    width: 100%;
  }
  .merchant-header-footer{
    margin-top: 34vh;
    min-height: 10vh;
    padding: 2vh 0;
    background-color: white;
    text-align: left;
    .title{
      color: #494949;
      font-weight: bold;
      font-size: 2vw;
    }
    .description{
      color: #7a7a7a;
      font-weight: bold;
      font-size: 1.6vw;
    }
    svg{
      margin: 1.4vh 0.5vw;
      vertical-align: middle;
    }
  }

  &::before {
    z-index: -1;
    height: 100%;
    width: 100%;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* // background-image: url(http://web.frfr.me/dev/world-map-optimized.jpg); */
    /* background-image: url(https://images.unsplash.com/photo-1450849608880-6f787542c88a?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&s=786a67dca1d8791d181bfd90b16240d9); */
    background-position: center center;
    background-size: cover;
    opacity: 0.5;
  }

  &.bg-1::before{
    background-image: url(../../assets/img/bg/1.jpg);
  }
  &.bg-2::before{
    background-image: url(../../assets/img/bg/2.jpg);
  }
  &.bg-3::before{
    background-image: url(../../assets/img/bg/3.jpg);
  }
  &.bg-4::before{
    background-image: url(../../assets/img/bg/4.jpg);
  }
  &.bg-5::before{
    background-image: url(../../assets/img/bg/5.jpg);
  }
  &.bg-6::before{
    background-image: url(../../assets/img/bg/6.jpg);
  }
  &.bg-7::before{
    background-image: url(../../assets/img/bg/7.jpg);
  }
  &.bg-8::before{
    background-image: url(../../assets/img/bg/8.jpg);
  }
  &.bg-9::before{
    background-image: url(../../assets/img/bg/9.jpg);
  }
  &.bg-10::before{
    background-image: url(../../assets/img/bg/10.jpg);
  }
  &.bg-11::before{
    background-image: url(../../assets/img/bg/11.jpg);
  }
  &.bg-12::before{
    background-image: url(../../assets/img/bg/12.jpg);
  }
  &.bg-13::before{
    background-image: url(../../assets/img/bg/13.jpg);
  }
}

/* body */
.merchant-body{
  padding-top: 5vh;
  min-height: 50vh;
  color: #4c4c4c;
  background-color: #f7f7f7;

  .info{
    .description, .gallery, .contact-information, .map{
      /* border-radius: 10px; */
      /* border: solid 1px grey; */
      background-color: white;
      min-height: 10vh;
      /* margin: 0 1vw 0 1vw; */
      /* padding: 1vw; */
      h3{
        color: white;
        font-weight: normal;
        background-color: #4c4c4c;
        /* height: 4vh; */
        margin: 0;
        vertical-align: middle;
        text-align: left;
        padding: 2.3vh 1vw 1vh 1.2vw;
      }
      p{
        text-align: left;
        padding: 3vh 1vw 3vh 1.2vw;
        margin: 0;
      }
    }

    .description, .contact-information{
      margin: 0 1.5vw 0 3vw;
    }
    .contact-information{
      padding-bottom: 1vh;
      h3{
        margin-bottom: 2vh;
      }
      p{
        padding: 1vh 1vw;
        svg, i{
          padding-right: 0.2vw;
        }
      }


    }
    .map{
      margin: 0 3vw 0 1.5vw;
    }


    .map{
      padding: 0;
    }

    .vue-map-container{
      min-height: 61vh;
    }
  }

  .panorama{
    min-height: 35vh;
    margin: 5vh 3vw;
    /* border-radius: 10px;
    border: solid 1px grey; */
    overflow: hidden;

    h3{
      color: white;
      font-weight: normal;
      background-color: #4c4c4c;
      /* height: 4vh; */
      margin: 0;
      vertical-align: middle;
      text-align: left;
      padding: 2.3vh 1vw 1vh 1.2vw;
    }

    .map{
      height: 100%;
      position: absolute;
      width: 100%;
    }
  }
}

a, a:active, a:hover, a:focus, a:visited{
  color: #4c4c4c;
  text-decoration: none;
}

/* sidebar menu width */
.el-tabs__nav-scroll{
  width: 12vw;
}

</style>



// WEBPACK FOOTER //
// src/components/merchants/MainMerchantView.vue